import { css } from "styled-components";
/** @class PropertyCardPhotoFooterMixin */

/** @method */

export var PropertyCardPhotoFooterMixin = /*#__PURE__*/css(["grid-area:photo-bottom;z-index:1;"]);